<template>
  <FacebookAudienceSourceCard
    v-if="isFacebookAudience"
    :type="type === 'facebook_custom_audiences' ? 'Custom Audience' : 'Saved Audience'"
    :facebook-audience="source"
  />
  <SavedQuerySourceCard v-else-if="isSavedQuery" :saved-query="source" />
  <GaUserListSourceCard v-else-if="isGaUserList" :ga-user-list="source" />
  <span v-else>Uknown source</span>
</template>

<script>
import moment from 'moment';
import FacebookAudienceSourceCard from './facebook-audience-source-card.vue';
import SavedQuerySourceCard from './saved-query-source-card.vue';
import GaUserListSourceCard from './ga-user-list-source-card.vue';

export default {
  components: {
    FacebookAudienceSourceCard,
    SavedQuerySourceCard,
    GaUserListSourceCard,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    source: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isFacebookAudience() {
      return ['facebook_custom_audiences', 'facebook_saved_audiences'].indexOf(this.type) >= 0;
    },
    isSavedQuery() {
      return this.type === 'saved_queries';
    },
    isGaUserList() {
      return this.type === 'ga_user_list';
    },
    sourceType() {
      if (this.isFacebookAudience) {
        return 'Facebook Audience';
      }

      if (this.isSavedQuery) {
        return 'CRM: Saved Query';
      }

      return 'Source Type Unavailable';
    },
    sourceUpdatedAt() {
      if (!this.source?.updated_at) {
        return '';
      }

      return moment(this.audience.model.updated_at).format('DD-MM-YYYY');
    },
  },
};
</script>
